import { aiPhotoImprovePaymium } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoImprove';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { createSelector } from 'reselect';

export const isPaymiumSelector = createSelector(
    UserSelectors.isPaidUser,
    UserSelectors.isCorpUser,
    (isPaid, isCorpUser) => aiPhotoImprovePaymium || isPaid || isCorpUser
);
